module.exports = __webpack_public_path__ + "img/first_therapy--active.9254752b.svg";